import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const UserNavIcon: FC<IconType> = (props) => {
  const { width, height, color, onClick } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      onClick={onClick}
      viewBox="-4 -4 40 40"
    >
      <rect
        x={1}
        y={4}
        width={30}
        height={24}
        rx={3}
        ry={3}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        data-cap="butt"
        x1={18}
        y1={4}
        x2={18}
        y2={28}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        data-color="color-2"
        x1={22}
        y1={11}
        x2={27}
        y2={11}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        data-color="color-2"
        x1={22}
        y1={16}
        x2={27}
        y2={16}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        data-color="color-2"
        x1={22}
        y1={21}
        x2={27}
        y2={21}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
    </svg>
  );
};
